import {
  createFrontendModule,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { FileText } from 'lucide-react';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';

// Create a custom techdocs navigation item with better icon
// IMPORTANT: No 'name' property to ensure ID matches the original 'nav-item:techdocs'
const customTechDocsNavItem = NavItemBlueprint.make({
  params: {
    title: 'Docs',
    icon: FileText as IconComponent,
    routeRef: techdocsPlugin.routes.root,
  },
});

// Apply override to replace the factory function
const customTechDocsNavExtension = customTechDocsNavItem.override({
  factory: (originalFactory, context) => {
    return originalFactory(context);
  },
});

// Create a module that contains our custom techdocs configurations
// Using 'techdocs' as pluginId since we're overriding techdocs plugin
export const customTechDocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [
    customTechDocsNavExtension, // Add the custom nav item with override
    // Add more techdocs customizations here later
  ],
});